const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStockicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    enableBackground: "new 0 0 1200 1200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5C63A6",
    d: "M436.857,88.55c0,11.33-4.989,17.315-6.414,17.6H302.821c-1.496-0.285-6.486-6.271-6.486-17.6 c0-11.33,4.989-17.387,6.414-17.672h127.621C431.939,71.235,436.857,77.22,436.857,88.55z",
    style: {
      fill: "rgb(3, 36, 47)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C8FD3",
    d: "M419.754,127.528v36.769h-26.08c-27.15,0-53.372,4.062-78.171,11.401v-48.17H419.754z",
    style: {
      fill: "rgb(66, 182, 187)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C8FD3",
    d: "M1150,1105.037c0,13.254-8.337,24.085-18.599,24.085H68.669c-10.261,0-18.669-10.831-18.669-24.085 c0-13.325,8.408-24.156,18.669-24.156h1062.732C1141.663,1080.881,1150,1091.712,1150,1105.037z",
    style: {
      fill: "rgb(66, 182, 187)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C63A6",
    points: "495.714,927.392 495.714,1029.219 444.765,978.27 \t",
    style: {
      fill: "rgb(3, 36, 47)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C63A6",
    points: "481.25,1044.967 378.139,1044.967 429.658,993.377 \t",
    style: {
      fill: "rgb(3, 36, 47)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C63A6",
    points: "414.552,978.27 363.033,1029.789 363.033,926.751 \t",
    style: {
      fill: "rgb(3, 36, 47)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C63A6",
    points: "481.25,911.645 429.658,963.164 378.139,911.645 \t",
    style: {
      fill: "rgb(3, 36, 47)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730.508,
    y: 913.497,
    fill: "#5C63A6",
    width: 78.383,
    height: 140.947,
    style: {
      fill: "rgb(3, 36, 47)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 618.421,
    y: 913.497,
    fill: "#5C63A6",
    width: 90.711,
    height: 140.947,
    style: {
      fill: "rgb(3, 36, 47)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.733,
    y: 913.497,
    fill: "#5C63A6",
    width: 79.31,
    height: 140.947,
    style: {
      fill: "rgb(3, 36, 47)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C63A6",
    points: "487.52,822.786 436.001,874.305 436.001,771.196 \t",
    style: {
      fill: "rgb(3, 36, 47)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C63A6",
    points: "554.146,756.09 502.627,807.609 451.108,756.09 \t",
    style: {
      fill: "rgb(3, 36, 47)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C63A6",
    points: "569.323,771.196 569.323,874.305 517.733,822.786 \t",
    style: {
      fill: "rgb(3, 36, 47)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5C63A6",
    points: "554.146,889.412 451.108,889.412 502.627,837.893 \t",
    style: {
      fill: "rgb(3, 36, 47)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.297,
    y: 413.412,
    fill: "#8C8FD3",
    width: 552.388,
    height: 67.837,
    style: {
      fill: "rgb(66, 182, 187)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.297,
    y: 588.349,
    fill: "#8C8FD3",
    width: 552.388,
    height: 69.619,
    style: {
      fill: "rgb(66, 182, 187)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.297,
    y: 502.627,
    fill: "#8C8FD3",
    width: 552.388,
    height: 64.345,
    style: {
      fill: "rgb(66, 182, 187)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.297,
    y: 325.909,
    fill: "#8C8FD3",
    width: 552.388,
    height: 66.127,
    style: {
      fill: "rgb(66, 182, 187)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C63A6",
    d: "M1045.609,440.205v619.299H886.062V315.22c0-5.914-4.774-10.689-10.689-10.689H301.609 c-5.842,0-10.689,4.774-10.689,10.689v744.284H138.359c0.499-1.212,0.783-2.566,0.783-3.99V440.205 c0-140.306,114.155-254.531,254.533-254.531h397.472C931.454,185.674,1045.609,299.899,1045.609,440.205z",
    style: {
      fill: "rgb(3, 36, 47)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockicon);
export default __webpack_public_path__ + "static/media/stockicon.a6bd04e6ad4fc3e6144b3be864cab871.svg";
export { ForwardRef as ReactComponent };